import { useI18n } from '../../../i18n';
// ============================================
// DailyTransactionsChart - Line chart
// ============================================

import {
  AreaChart, Area, XAxis, YAxis, Tooltip,
  ResponsiveContainer, CartesianGrid,
} from 'recharts';
import { cn } from '../../../utils/cn';

export interface DailyTransactionData {
  date: string;
  count: number;
}

// Bug #66: ô "Search transactions" và nút Filter đã được GỠ BỎ theo yêu cầu.
// Chúng không lọc gì trên chính biểu đồ này — bấm vào chỉ nhảy sang trang
// Payments, nên người dùng đọc là "bấm không có tác dụng/không điều hướng".
interface Props {
  data: DailyTransactionData[];
  className?: string;
}

interface TooltipProps {
  active?: boolean;
  payload?: Array<{ value: number }>;
  label?: string;
}

function CustomTooltip({ active, payload, label }: TooltipProps) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg bg-white px-3 py-2 shadow-lg ring-1 ring-black/5 text-xs">
      <p className="font-normal text-[#191B23]">{label}</p>
      <p className="text-[#59B4E2]"> count: {payload[0].value} </p>
    </div>
  );
}

export function DailyTransactionsChart({ data, className }: Props) {
  const { t } = useI18n();
  return (
    <div className={cn('rounded-2xl bg-white p-6 shadow-sm', className)}>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-base font-bold text-[#191B23]">{t('dailyTransactionsCount')}</h3>
      </div>

      {/* Chart */}
      <div className="h-[220px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 5, right: 5, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="txGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#004AC6" stopOpacity={0.15} />
                <stop offset="95%" stopColor="#004AC6" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" vertical={false} />
            <XAxis
              dataKey="date"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 10, fill: '#94A3B8' }}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 10, fill: '#94A3B8' }}
              width={30}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="monotone"
              dataKey="count"
              stroke="#004AC6"
              strokeWidth={2}
              fill="url(#txGradient)"
              dot={false}
              activeDot={{ r: 4, fill: '#004AC6' }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
